export const ACCESS_TOKEN = 'admin-ftrsm-at'
export const REFRESH_TOKEN = 'admin-ftrsm-rt'